import { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { User, Mail, Phone, Globe, BookOpen, Headphones, ExternalLink, Copy, Check, Download } from 'lucide-react';
import QRCode from 'qrcode';
import JSZip from 'jszip';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Iconos para cada tipo de enlace
const LINK_ICONS = {
  link: <Globe className="w-5 h-5" />,
  audiolibro: <Headphones className="w-5 h-5" />,
  podcast: <Headphones className="w-5 h-5" />,
  ebook: <BookOpen className="w-5 h-5" />,
  amazon: <BookOpen className="w-5 h-5" />,
  youtube: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  ),
  curso: <BookOpen className="w-5 h-5" />,
  tienda: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  ),
  web: <Globe className="w-5 h-5" />,
  spotify: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
    </svg>
  ),
  apple: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/>
    </svg>
  ),
  viubux: <Headphones className="w-5 h-5" />,
  referido: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
    </svg>
  ),
};

// Social media icons
const SOCIAL_ICONS = {
  facebook: (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  ),
  instagram: (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  ),
  twitter: (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  ),
  tiktok: (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
    </svg>
  ),
  youtube: (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  ),
  linkedin: (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  ),
  spotify: (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
    </svg>
  ),
};

const LinkTreePage = () => {
  const { username } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const [showQR, setShowQR] = useState(false);
  const [qrDownloading, setQrDownloading] = useState(false);
  const qrRef = useRef(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/public/linkpage/${username}`);
        const data = response.data;
        // Redirección dinámica: si el autor la activó, redirige al destino elegido
        if (data.referral_redirect_enabled && data.referral_redirect_url) {
          try {
            // Preservar el tracking de referido cross-domain (best-effort)
            axios.get(`${BACKEND_URL}/api/referral/set-cookie?ref=${encodeURIComponent(username)}`, { withCredentials: true }).catch(() => {});
          } catch (e) { /* noop */ }
          const dest = data.referral_redirect_url;
          const sep = dest.includes('?') ? '&' : '?';
          window.location.replace(`${dest}${sep}ref=${encodeURIComponent(username)}`);
          return;
        }
        setProfile(data);
      } catch (err) {
        if (err.response?.status === 404) {
          setError('Usuario no encontrado');
        } else {
          setError('Error al cargar el perfil');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [username]);

  const profileUrl = `${window.location.origin}/${username}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(profileUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-violet-900 via-purple-900 to-indigo-900 flex items-center justify-center">
        <div className="animate-spin w-12 h-12 border-4 border-white border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-violet-900 via-purple-900 to-indigo-900 flex items-center justify-center p-4">
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 text-center max-w-md">
          <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <User className="w-10 h-10 text-red-400" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">{error}</h1>
          <p className="text-white/60 mb-6">El enlace que seguiste no existe o ha sido eliminado.</p>
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 bg-violet-600 hover:bg-violet-700 text-white px-6 py-3 rounded-full transition-colors"
          >
            Ir al inicio
          </Link>
        </div>
      </div>
    );
  }

  const bgColor = profile.link_page_bg_color || 'linear-gradient(135deg, #7c3aed 0%, #4c1d95 100%)';
  const hasSocialLinks = profile.social_links && Object.values(profile.social_links).some(v => v);

  // Determinar estilo de fondo
  const getBackgroundStyle = () => {
    if (profile.link_page_wallpaper) {
      return { backgroundColor: '#0f0c29' };
    }
    if (bgColor.includes('gradient')) {
      return { background: bgColor };
    }
    return { background: `linear-gradient(135deg, ${bgColor} 0%, ${adjustColor(bgColor, -30)} 100%)` };
  };

  const wallpaperBlur = profile.link_page_wallpaper_blur ?? 12;

  // Detectar si el fondo es oscuro para elegir la versión del isotipo/logo
  const isDarkBackground = () => {
    if (profile.link_page_wallpaper) return true; // overlay oscuro sobre la imagen
    const src = bgColor || '';
    const hexMatch = src.match(/#([0-9a-fA-F]{6})/);
    if (!hexMatch) return true;
    const hex = hexMatch[1];
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return lum < 0.6;
  };
  const darkBg = isDarkBackground();
  const markSrc = darkBg ? '/viubux-mark-all-white-1024.png' : '/viubux-mark-1024.png';

  // Descarga del QR en alta resolución (.zip con 512/1024/2048 px)
  const loadImage = (src) => new Promise((resolve, reject) => {
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
  const roundRect = (ctx, x, y, w, h, r) => {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  };
  const makeQrBlob = async (size) => {
    const canvas = document.createElement('canvas');
    await QRCode.toCanvas(canvas, profileUrl, {
      width: size,
      margin: 2,
      errorCorrectionLevel: 'H',
      color: { dark: '#7c3aed', light: '#ffffff' }
    });
    const ctx = canvas.getContext('2d');
    try {
      const logo = await loadImage('/viubux-mark-1024.png');
      const ls = Math.round(size * 0.2);
      const x = (size - ls) / 2;
      const y = (size - ls) / 2;
      const pad = Math.round(ls * 0.14);
      ctx.fillStyle = '#ffffff';
      roundRect(ctx, x - pad, y - pad, ls + 2 * pad, ls + 2 * pad, Math.round(ls * 0.22));
      ctx.fill();
      ctx.drawImage(logo, x, y, ls, ls);
    } catch (e) { /* si el logo falla, se exporta el QR limpio */ }
    return await new Promise((res) => canvas.toBlob(res, 'image/png'));
  };
  const downloadQrZip = async () => {
    setQrDownloading(true);
    try {
      const zip = new JSZip();
      for (const size of [512, 1024, 2048]) {
        const blob = await makeQrBlob(size);
        zip.file(`viubux-qr-${username}-${size}px.png`, blob);
      }
      const content = await zip.generateAsync({ type: 'blob' });
      const url = URL.createObjectURL(content);
      const a = document.createElement('a');
      a.href = url;
      a.download = `viubux-qr-${username}.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('QR zip error', e);
    } finally {
      setQrDownloading(false);
    }
  };

  return (
    <div 
      className="min-h-screen py-8 px-4 relative overflow-hidden"
      style={getBackgroundStyle()}
    >
      {profile.link_page_wallpaper && (
        <>
          <div
            className="fixed inset-0 pointer-events-none"
            style={{
              backgroundImage: `url(${profile.link_page_wallpaper})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: `blur(${wallpaperBlur}px)`,
              transform: 'scale(1.2)'
            }}
          />
          <div className="fixed inset-0 bg-gradient-to-b from-black/20 via-black/40 to-black/60 pointer-events-none" />
        </>
      )}
      {/* Isotipo Viubux (esquina superior izquierda, versión según fondo) */}
      <a href="/" className="absolute top-4 left-4 z-20 transition-transform hover:scale-105" title="Viubux" data-testid="linktree-brand-mark">
        <img src={markSrc} alt="Viubux" className="h-12 w-auto drop-shadow-lg" onError={(e) => { e.target.style.display = 'none'; }} />
      </a>
      <div className="max-w-lg mx-auto relative z-10">
        {/* Banner Image */}
        {profile.link_page_banner && (
          <div className="rounded-t-3xl overflow-hidden mb-[-60px] relative z-0">
            <img 
              src={profile.link_page_banner} 
              alt="Banner"
              className="w-full h-32 object-cover"
            />
          </div>
        )}

        {/* Profile Card */}
        <div className={`bg-white/10 backdrop-blur-lg rounded-3xl p-6 ${profile.link_page_banner ? 'pt-16' : ''} relative z-10`}>
          {/* Profile Photo & Book Cover */}
          <div className="flex justify-center items-end gap-4 mb-4">
            {/* Book Cover (if exists) */}
            {profile.link_page_book_cover && (
              <div className="w-20 h-28 rounded-lg overflow-hidden shadow-lg transform -rotate-6">
                <img 
                  src={profile.link_page_book_cover} 
                  alt="Libro"
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            
            {/* Profile Photo */}
            <div className="relative">
              {profile.profile_photo ? (
                <img 
                  src={profile.profile_photo} 
                  alt={profile.full_name}
                  className="w-28 h-28 rounded-full object-cover border-4 border-white/30 shadow-xl"
                />
              ) : (
                <div className="w-28 h-28 rounded-full bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center border-4 border-white/30 shadow-xl">
                  <span className="text-4xl font-bold text-white">
                    {profile.full_name?.charAt(0)?.toUpperCase() || '?'}
                  </span>
                </div>
              )}
              {profile.user_type === 'author' && (
                <div className="absolute -bottom-1 -right-1 bg-amber-500 rounded-full p-1.5">
                  <BookOpen className="w-4 h-4 text-white" />
                </div>
              )}
            </div>
          </div>

          {/* Name & Username */}
          <div className="text-center mb-4">
            <h1 className="text-2xl font-bold text-white">{profile.full_name}</h1>
            <p className="text-white/60 text-sm">@{profile.username}</p>
          </div>

          {/* Bio/Sinopsis */}
          {profile.link_page_bio && (
            <p className="text-white/80 text-center text-sm mb-6 leading-relaxed max-w-md mx-auto">
              {profile.link_page_bio}
            </p>
          )}

          {/* Social Links */}
          {hasSocialLinks && (
            <div className="flex justify-center gap-3 mb-6">
              {Object.entries(profile.social_links).map(([platform, url]) => {
                if (!url) return null;
                return (
                  <a
                    key={platform}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors"
                  >
                    {SOCIAL_ICONS[platform] || <Globe className="w-5 h-5" />}
                  </a>
                );
              })}
            </div>
          )}

          {/* Custom Links */}
          {profile.link_page_links && profile.link_page_links.length > 0 && (
            <div className="space-y-3 mb-6">
              {profile.link_page_links.map((link, index) => (
                <a
                  key={link.id || index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-4 bg-white/10 hover:bg-white/20 backdrop-blur rounded-xl p-4 transition-all transform hover:scale-[1.02] group"
                >
                  {link.image ? (
                    <img src={link.image} alt="" className="w-10 h-10 rounded-lg object-cover" />
                  ) : (
                    <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center text-white">
                      {LINK_ICONS[link.icon] || LINK_ICONS.link}
                    </div>
                  )}
                  <span className="flex-1 text-white font-medium">{link.title}</span>
                  <ExternalLink className="w-4 h-4 text-white/40 group-hover:text-white/80 transition-colors" />
                </a>
              ))}
            </div>
          )}

          {/* Contact Info */}
          {(profile.email_public || profile.phone || profile.website) && (
            <div className="flex justify-center gap-4 py-4 border-t border-white/10 mb-4">
              {profile.email_public && (
                <a href={`mailto:${profile.email_public}`} className="text-white/60 hover:text-white">
                  <Mail className="w-5 h-5" />
                </a>
              )}
              {profile.phone && (
                <a href={`tel:${profile.phone}`} className="text-white/60 hover:text-white">
                  <Phone className="w-5 h-5" />
                </a>
              )}
              {profile.website && (
                <a href={profile.website} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white">
                  <Globe className="w-5 h-5" />
                </a>
              )}
            </div>
          )}

          {/* Referral CTA - AL FINAL */}
          {profile.referral_code && (
            <a
              href={`/?ref=${profile.username}`}
              className="block w-full bg-white text-gray-900 text-center py-4 rounded-xl font-semibold transition-all transform hover:scale-[1.02]"
            >
              <div className="flex items-center justify-center gap-2">
                <Headphones className="w-5 h-5" />
                <span>Únete a Viubux</span>
              </div>
            </a>
          )}
        </div>

        {/* QR Code Toggle */}
        <div className="mt-6 text-center">
          <button
            onClick={() => setShowQR(!showQR)}
            className="text-white/60 hover:text-white text-sm flex items-center gap-2 mx-auto"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
            </svg>
            {showQR ? 'Ocultar QR' : 'Mostrar QR'}
          </button>
        </div>

        {/* QR Code Card */}
        {showQR && (
          <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 text-center mt-4">
            <div className="relative inline-block mb-4">
              <div className="bg-white rounded-2xl p-4 inline-block" ref={qrRef}>
                <QRCodeSVG 
                  value={profileUrl}
                  size={180}
                  level="H"
                  includeMargin={true}
                  fgColor="#7c3aed"
                  imageSettings={{
                    src: "/viubux-mark-512.png",
                    x: undefined,
                    y: undefined,
                    height: 40,
                    width: 40,
                    excavate: true,
                  }}
                />
              </div>
              <button
                onClick={downloadQrZip}
                disabled={qrDownloading}
                className="absolute top-1.5 right-1.5 p-1.5 bg-white/80 hover:bg-white rounded-full shadow-sm text-violet-600 hover:text-violet-700 backdrop-blur transition-all hover:scale-110 disabled:opacity-60"
                title="Descargar QR en alta resolución (.zip · 512 / 1024 / 2048 px)"
                data-testid="download-qr-btn"
              >
                {qrDownloading ? (
                  <div className="w-3.5 h-3.5 border-2 border-violet-500 border-t-transparent rounded-full animate-spin" />
                ) : (
                  <Download className="w-3.5 h-3.5" />
                )}
              </button>
            </div>
            <div className="flex items-center justify-center gap-2">
              <span className="text-white/60 text-sm truncate max-w-[200px]">{profileUrl}</span>
              <button 
                onClick={copyToClipboard}
                className="p-2 hover:bg-white/10 rounded-lg transition-colors"
                title="Copiar enlace"
              >
                {copied ? (
                  <Check className="w-4 h-4 text-green-400" />
                ) : (
                  <Copy className="w-4 h-4 text-white/60" />
                )}
              </button>
            </div>
            <p className="text-white/40 text-[11px] mt-3">Descarga el QR en alta resolución para materiales impresos (.zip: 512, 1024 y 2048 px)</p>
          </div>
        )}

        {/* Footer */}
        <div className="text-center mt-8">
          <a href="/" className="inline-flex items-center gap-2 text-white/40 text-sm hover:text-white/60 transition-colors">
            <img src="/viubux_isotipo.png" alt="Viubux" className="h-4 opacity-60" onError={(e) => e.target.style.display = 'none'} />
            Powered by Viubux Media
          </a>
        </div>
      </div>
    </div>
  );
};

// Helper function to darken/lighten color
function adjustColor(color, amount) {
  const clamp = (num) => Math.min(255, Math.max(0, num));
  
  // Remove # if present
  color = color.replace('#', '');
  
  // Parse hex
  const num = parseInt(color, 16);
  const r = clamp((num >> 16) + amount);
  const g = clamp(((num >> 8) & 0x00FF) + amount);
  const b = clamp((num & 0x0000FF) + amount);
  
  return `#${(1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1)}`;
}

export default LinkTreePage;
